import index from '../objects/global/index'

index()
